// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2aqNI","links":"Footer_links__3UDCj","link-item":"Footer_link-item__2w9LW","copy-right":"Footer_copy-right__DMMfM"};